/**
 * Angular imports.
 */
import { Component, OnInit, Output, EventEmitter, OnDestroy, Input, OnChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
/**
 * Rxjs imports.
 */
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

/**
 * Constant imports.
 */
import { MEMBERS_LIST_TYPE, COMMUNITY_USER_TYPE, COMMUNITY_MEMBERS_ACTION, NUMBERS } from '../../constants/app.constants';

/**
 * Service imports.
 */
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { GetService } from '../../dataservices/get.service';
/**
 * Interface import.
 */
import { CommunityMember } from '../../onboarding/interface/global.model';
// import { CommunityMembersResponse } from '../../onboarding/interface/apiResponse.model';

/**
 * Multi select checkbox selection.
 */
@Component({
  selector: 'app-multi-check-box-select',
  templateUrl: './multi-check-box-select.component.html',
  styleUrls: ['./multi-check-box-select.component.scss']
})
export class MultiCheckBoxSelectComponent implements OnInit, OnDestroy, OnChanges {

  /**
   * Total checkbox selected limit.
   * Suggestion list must have id, name property.
   * selected list must have id, name property.
   * Title of the selected list.
   * No data found msg in case of search.
   * Max limit exceed error msg.
   * Search filter placeholder.
   * Title for the list.
   * Api in process flag for loading and no data available.
   * In view all page or not.
   */
  @Input() selectedLimit = 0;
  @Input() suggestionList = [];
  @Input() selectedList = [];
  @Input() selectedTitle = '';
  @Input() noDataFoundLabel = '';
  @Input() maxLimitErrorLabel = '';
  @Input() filterPlaceholder = '';
  @Input() title = '';
  @Input() apiInProcess = false;
  @Input() isViewAllEnable = false;
  @Input() loggedInUserCustomId = '';
  @Input() communityCreatedBy = {};
  @Input() showExistingUserFlag = false;
  /**
   * Selected member those are removed.
   */
  @Input() membersSelectedRemoved?;

  /**
   * Remove the subscription.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Store searched keyword.
   * Max limit error msg to show in the DOM.
   * Filter for the search.
   * Config for perfectScroll.
   * Show Forward Arrow In case of Community
   * Show Existing User Flag for Mobile Web
   */
  public keyword = '';
  public maxLimitErrorMsg = '';
  public search: Subject<string> = new Subject();
  public config = {};
  public memberListType = MEMBERS_LIST_TYPE;
  public showForwardArrow = true;
  public showExistingUsersFlag = false;
  /**
   * Community member type constant.
   */
  public memberType = COMMUNITY_USER_TYPE;
  /**
   * Selected removed member.
   */
  public selctedRemovedMember = [];
  /**
   * Constant number
   */
  public NUMBERS = NUMBERS;
  /**
   * Member list.
   */
  public memberList: CommunityMember[] = [];

  /**
   * Emit search keyword outside.
   * emit back to suggestions outside.
   * emit view all flag outside.
   * emit on scroll event outside.
   */
  @Output() emitSearchKey: EventEmitter<string> = new EventEmitter();
  @Output() emitBackToSuggestions: EventEmitter<string> = new EventEmitter();
  @Output() emitViewAll: EventEmitter<string> = new EventEmitter();
  @Output() emitOnScroll: EventEmitter<string> = new EventEmitter();
  @Output() emitExistingUserFlag: EventEmitter<boolean> = new EventEmitter();

  @Output() emitCheckUncheckUser: EventEmitter<boolean> = new EventEmitter();
  @Output() emitOnMemberScroll: EventEmitter<string> = new EventEmitter();
  @Output() emitMembersSelected: EventEmitter<object> = new EventEmitter();
  @Output() emitMembersRemoved: EventEmitter<object> = new EventEmitter();

  public showMemberModal = false;
  /**
   * Offset for existing member list.
   */
  public existingMembersOffset = NUMBERS.ONE;
  /**
   * Existing members modal.
   */
  public existingmembersLoader = false;
  /**
   * Community id.
   */
  public communityId: string;

  /**
   * Constructor
   */

  constructor(public mls: NewLanguageService,
    private getApiAervice: GetService,
    public fcs: FunCollectionService,
    private route: ActivatedRoute) {
  }

  /**
   * Call Trigger search.
   */
  ngOnInit(): void {
    this.triggerSearch();
    this.communityId = this.route.snapshot.params['communityId'];
  }

  /**
   * Trigger the search with the debounce.
   */
  triggerSearch(): void {
    this.subscriptions.add(this.search.pipe(
      debounceTime(300)
    ).subscribe(key => {
      this.keyword = key;
      this.emitSearchKey.emit(this.keyword);
      this.scrollToTop();
    }));
  }

  /**
   * Back To suggestion and connection
   */
  backToSuggestion(): void {
    this.emitBackToSuggestions.emit();
  }

  /**
   * Search in the list.
   */
  searchInTheList(key: string): void {
    this.search.next(key);
  }

  /**
   * Remover connection search
   */
  resetSearchBox(): void {
    document.querySelector<HTMLInputElement>('#conSearch').value = '';
    this.keyword = '';
    this.emitSearchKey.emit(this.keyword);
    this.scrollToTop();
  }

  /**
   * Scroll to top when list gets empty/small.
   */
  scrollToTop(): void {
    const myDiv = document.getElementById('containerDiv');
    if (myDiv) {
      myDiv.scrollTop = 0;
    }
  }

  /**
   * Emit the view All key.
   */
  viewAll(key: string): void {
    this.emitViewAll.emit(key);
    this.scrollToTop();
  }


  /**
   * add the selected items in selection array.
   */
  add(event, select): boolean {
    this.resetErrorMsg();
    if (event.target.checked == true) {
      if (this.selectedList.length >= this.selectedLimit) {
        this.maxLimitErrorMsg = `${this.maxLimitErrorLabel} ${this.selectedLimit} ${this.title}`;
        event.target.checked = false;
        return false;
      }
      this.selectedList.push(select);
      select['action'] = COMMUNITY_MEMBERS_ACTION.ADD;
      this.emitMembersSelected.emit(select);
      this.emitCheckUncheckUser.emit(true);
    } else {
      const index = this.selectedList.findIndex((item) => {
        return item.custom_id === event.target.value;
      });
      if (index != -1) {
        this.selectedList.splice(index, 1);
      }
      this.emitCheckUncheckUser.emit(false);
      select['action'] = COMMUNITY_MEMBERS_ACTION.REMOVE;
      this.emitMembersRemoved.emit(select);
    }
  }

  /**
   * check Value
   */
  checkVal(select): boolean {
    const selected = this.selectedList.filter(item => item.custom_id == select.custom_id);
    return (selected.length > 0) ? true : false;
  }

  /**
   * unTag
   */
  unTag(select): void {
    select['action'] = COMMUNITY_MEMBERS_ACTION.REMOVE;
    this.emitMembersRemoved.emit(select);
    const index = this.selectedList.findIndex((item) => {
      return item.custom_id === select.custom_id;
    });

    if (index != -1) {
      this.selectedList.splice(index, 1);
      this.emitCheckUncheckUser.emit(false);
    }
    this.resetErrorMsg();
    if (select.connection_status == NUMBERS.ZERO) {
      this.suggestionList[1].list.findIndex((item) => {
        return item.custom_id === select.custom_id;
      });
    }

    this.selctedRemovedMember = this.membersSelectedRemoved.filter(data => data.action == 'remove');
  }

  /**
   * onScroll
   */
  onScroll(): void {
    this.emitOnScroll.emit();
  }

  /**
   * onScroll
   */
  onMemberScroll(): void {
    this.emitOnMemberScroll.emit();
  }

  /**
   * reset Error Msg
   */
  resetErrorMsg(): void {
    this.maxLimitErrorMsg = '';
  }


  /**
   * On Changes
   */
  ngOnChanges(): void {
    this.showExistingUsersFlag = this.showExistingUserFlag;
  }


  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
  closeExistingMember(): void {
    this.showMemberModal = false;
    this.existingMembersOffset = NUMBERS.ONE;
    this.memberList = [];
  }


}
